var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.722,
    height: 10.722,
    viewBox: "0 0 10.722 10.722",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(-1351.423 -1069.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M1353.5,1076.761a.336.336,0,0,1,.268-.134h1.676a.335.335,0,1,1,0,.67h-1.508l-1.508,2.011h8.712l-1.508-2.011h-1.508a.335.335,0,1,1,0-.67h1.676a.338.338,0,0,1,.268.134l2.01,2.681a.335.335,0,0,1-.268.536h-10.052a.335.335,0,0,1-.335-.335.331.331,0,0,1,.067-.2Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M1356.784,1069.926a2.01,2.01,0,1,0,2.01,2.01A2.01,2.01,0,0,0,1356.784,1069.926Zm-2.681,2.01a2.68,2.68,0,1,1,3.016,2.66v3.707a.335.335,0,0,1-.67,0V1074.6a2.681,2.681,0,0,1-2.346-2.662Z",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceIcon);
export default __webpack_public_path__ + "static/media/place-icon.fa8c0712f8b4ac8cfd81cb0718681427.svg";
export { ForwardRef as ReactComponent };